import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import { AssetDownloadItem } from 'components/AssetDownloadItem/AssetDownloadItem';
import { CheckboxRow } from 'components/CheckboxRow/CheckboxRow';
import { FormSection } from 'components/FormHelper/FormSection';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

const CONTENT = {
  [TENANT_ID.EDI]: {
    INTRO_TEXT: (
      <div key="edi_intro">Ich bin / wir sind damit einverstanden, dass die E.DIS Netz GmbH</div>
    ),
    APPROVAL_TEXTS: [
      <div key="edi_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="edi_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden auf
          der E.DIS Netz GmbH Homepage und im Netzanschlussportal veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
  [TENANT_ID.SHNG]: {
    INTRO_TEXT: (
      <div key="shng_intro">
        Ich bin / wir sind damit einverstanden, dass die Schleswig-Holstein Netz GmbH
      </div>
    ),
    APPROVAL_TEXTS: [
      <div key="shng_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="shng_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden auf
          der Schleswig-Holstein Netz GmbH Homepage und im Netzanschlussportal veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
  [TENANT_ID.AVA]: {
    INTRO_TEXT: (
      <div key="ava_intro">Ich bin / wir sind damit einverstanden, dass die Avacon Netz GmbH</div>
    ),
    APPROVAL_TEXTS: [
      <div key="ava_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="ava_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden auf
          der Avacon Netz GmbH Homepage und im Netzanschlussportal veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
  [TENANT_ID.BAG]: {
    INTRO_TEXT: (
      <div key="bag_intro">
        Ich bin / wir sind damit einverstanden, dass die Bayernwerk Netz GmbH
      </div>
    ),
    APPROVAL_TEXTS: [
      <div key="bag_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="bag_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden auf
          der Bayernwerk Netz GmbH Homepage und im Netzanschlussportal veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
  [TENANT_ID.LVN]: {
    INTRO_TEXT: (
      <div key="lvn_intro">
        Ich bin / wir sind damit einverstanden, dass die LEW Verteilnetz GmbH
      </div>
    ),
    APPROVAL_TEXTS: [
      <div key="lvn_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="lvn_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden auf
          der LEW Verteilnetz GmbH Homepage und im Netzanschlussportal veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
  [TENANT_ID.MTN]: {
    INTRO_TEXT: (
      <div key="mtn_intro">
        Ich bin / wir sind damit einverstanden, dass die Mitteldeutsche Netzgesellschaft Strom mbH,
        die Mitteldeutsche Netzgesellschaft Gas mbH und die Verteilnetz Plauen GmbH
      </div>
    ),
    APPROVAL_TEXTS: [
      <div key="mtn_approval_1">
        über gesetzliche, technische oder organisatorische Neuerungen sowie fachbezogene
        Veranstaltungen und das Installateurportal informiert{' '}
        <strong>[Info-Versand per E-Mail]</strong>
      </div>,
      <Fragment key="mtn_approval_2">
        <div>
          meine / unsere im Installateurverzeichnis gespeicherten Kontaktdaten (Name, Adresse,
          Telefonnummer, E-Mail-Adresse) in der <strong>Installateur-Suche</strong> für Kunden
          jeweils auf der Homepage der Mitteldeutschen Netzgesellschaft Strom mbH, Mitteldeutsche
          Netzgesellschaft Gas mbH und der Verteilnetz Plauen GmbH und im Netzanschlussportal
          veröffentlicht
        </div>
        <strong>
          Ohne Zustimmung finden die Kunden Ihr Unternehmen nicht in der Firmenauswahl.
        </strong>
      </Fragment>,
    ],
  },
};

const DEFAULT_CONFIRMATION_TEXT =
  'Mit Absenden dieser Anfrage bestätige ich / bestätigen wir, dass ich / wir die „Datenschutz“-Zustimmung und die hier aktuell hinterlegte „Informationen zum Datenschutz“ zur Kenntnis genommen habe / haben und mit Absenden dieser Anfrage bestätige ich / bestätigen wir, dass die oben unter „Inhaber / Gesellschafter / Teilhaber“ und unter „verantwortliche Fachkräfte“ genannten Personen die „Informationen zum Datenschutz“ gelesen haben und mit den in der „Datenschutz“-Zustimmung genannten Punkten einverstanden sind.';

export const DataPolicyContent = ({
  className,
  confirmationText,
  dsgvoAddressPublic,
  dsgvoCanSendMail,
  onChangeDsvgoAddressPublic,
  onChangeDsvgoCanSendMail,
  dsgvoAddressPublicName,
  dsgvoCanSendMailName,
  documents,
  shngDocuments,
  showAddressPublicApproval,
}) => {
  const CURRENT_CONTENT = CONTENT[getTenantId()];
  const filteredDocuments = documents.filter(
    ({ link, label }) => link && link !== '' && label && label !== ''
  );

  return (
    <div className={className}>
      {getTenantId() === TENANT_ID.SHNG && (
        <div>
          <FormSection subtitle="Grundsätze der Zusammenarbeit" />
          <div className="data-policy__down-section-wrapper">
            {shngDocuments.map(({ link, label }, index) => (
              <AssetDownloadItem key={`${label}_${index}`} asset={link} name={label} />
            ))}
          </div>
        </div>
      )}
      {filteredDocuments.length > 0 && (
        <FormSection subtitle="Informationen zum Datenschutz">
          <div className="data-policy__down-section-wrapper ">
            {filteredDocuments.map(({ link, label }, index) => (
              <AssetDownloadItem key={`${label}_${index}`} asset={link} name={label} />
            ))}
          </div>
        </FormSection>
      )}
      {getTenantId() === TENANT_ID.MTN && (
        <ul>
          <li>
            <a
              className="link"
              href="https://www.mitnetz-strom.de/datenschutzinformation"
              target="_blank"
              rel="noopener noreferrer">
              Informationen zum Datenschutz der Mitteldeutschen Netzgesellschaft Strom mbH
            </a>
          </li>
          <li>
            <a
              className="link"
              href="https://www.mitnetz-gas.de/datenschutzinformation"
              target="_blank"
              rel="noopener noreferrer">
              Informationen zum Datenschutz der Mitteldeutsche Netzgesellschaft Gas mbH
            </a>
          </li>
          <li>
            <a
              className="link"
              href="https://www.plauen-netz.de/datenschutzinformation"
              target="_blank"
              rel="noopener noreferrer">
              Informationen zum Datenschutz der Verteilnetz Plauen GmbH
            </a>
          </li>
        </ul>
      )}
      <FormSection subtitle="Zustimmungen zum Datenschutz">
        <div>{confirmationText}</div>
        <div className="data-policy__switch-section-intro-text">{CURRENT_CONTENT.INTRO_TEXT}</div>
        <div className="data-policy__switch-section-wrapper">
          <CheckboxRow
            name={dsgvoCanSendMailName}
            label={CURRENT_CONTENT.APPROVAL_TEXTS[0]}
            value={dsgvoCanSendMail}
            onChange={onChangeDsvgoCanSendMail}
          />
          {showAddressPublicApproval && (
            <CheckboxRow
              name={dsgvoAddressPublicName}
              label={CURRENT_CONTENT.APPROVAL_TEXTS[1]}
              value={dsgvoAddressPublic}
              onChange={onChangeDsvgoAddressPublic}
            />
          )}
        </div>
      </FormSection>
    </div>
  );
};

DataPolicyContent.propTypes = {
  className: PropTypes.string,
  confirmationText: PropTypes.string,
  dsgvoAddressPublic: PropTypes.bool.isRequired,
  dsgvoAddressPublicName: PropTypes.string.isRequired,
  dsgvoCanSendMail: PropTypes.bool.isRequired,
  dsgvoCanSendMailName: PropTypes.string.isRequired,
  onChangeDsvgoAddressPublic: PropTypes.func.isRequired,
  onChangeDsvgoCanSendMail: PropTypes.func.isRequired,
  documents: PropTypes.array.isRequired,
  shngDocuments: PropTypes.array,
  showAddressPublicApproval: PropTypes.bool,
};

DataPolicyContent.defaultProps = {
  className: '',
  confirmationText: DEFAULT_CONFIRMATION_TEXT,
  shngDocuments: [],
  showAddressPublicApproval: true,
};
